// Get minutes, seconds and milliseconds
const getLogTime = (): string => {
  return new Date().toJSON().slice(14, 22);
};

export default getLogTime;
